import React from 'react';
import './MatchHeader.css';
import dateFormatter from '../../../generic actions/DateFormatter';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import SportsTennisIcon from '@mui/icons-material/SportsTennis';

function MatchHeader({ matchDetails }) {
    const p1Won = Number(matchDetails.playerOne.score) > Number(matchDetails.playerTwo.score);

    const renderPlayer = (player, isWinner) => (
        <div className={`mh-player ${isWinner ? 'mh-player--winner' : ''}`}>
            <div className={`mh-avatar-ring ${isWinner ? 'mh-avatar-ring--winner' : ''}`}>
                <img
                    className='mh-avatar'
                    src={player.img}
                    alt={player.name}
                    onError={(e) => { e.target.style.display = 'none'; }}
                />
            </div>
            {isWinner && <EmojiEventsIcon className='mh-trophy' />}
            <span className={`mh-name ${isWinner ? 'mh-name--winner' : ''}`}>{player.name}</span>
            <span className={`mh-score ${isWinner ? 'mh-score--win' : 'mh-score--lose'}`}>{player.score}</span>
        </div>
    );

    return (
        <div className='mh-card'>
            <div className='mh-meta'>
                <span className='mh-meta-item'>
                    <CalendarTodayIcon sx={{ fontSize: 12 }} />
                    {dateFormatter(matchDetails.date)}
                </span>
                <span className='mh-meta-dot' />
                <span className='mh-meta-item'>
                    <SportsTennisIcon sx={{ fontSize: 12 }} />
                    {matchDetails.courtName}
                </span>
            </div>

            <div className='mh-players-row'>
                {renderPlayer(matchDetails.playerOne, p1Won)}
                <div className='mh-vs'>
                    <span>VS</span>
                </div>
                {renderPlayer(matchDetails.playerTwo, !p1Won)}
            </div>
        </div>
    );
}

export default MatchHeader;
